var ticketStatusIntToString = function(value) {
    if ( !value ) {
      return "";
    }
  
    var names = {
      "2" : "待受理",
      "3" : "处理中-未读",
      "5" : "已解决",
      "6" : "已关闭",
      "7" : "处理中-已读"
    };

    if ( !!names[value + ""] ) {
      return names[value + ""];
    }

    return '状态 ' + value;
};


export {
  ticketStatusIntToString
};


// WEBPACK FOOTER //
// ./src/assets/utils/TicketStatusUtil.js